import OurTakeHighlight from './our-take-highlight';
export { findOurTakeHighlightContent } from './helpers/find-highlight';
export { BannerType, OurTakeContent } from './types';
export default OurTakeHighlight;